export const shortTermFlg = {
  shortTerm: 1,
  commonTerm: 0,
};
